import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollButton } from "../ScrollButton";
import { VariableSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { useCallback, useEffect, useRef, useState } from "react";
export function SharedVirtualTableBody(props) {
    const { data, visibleColumns, adjustedColumns, bodyClassName, rowBodyClassName, gridTemplateColumns, onRowClick, isRowSelected, loadMore, } = props;
    const listRef = useRef(null);
    const scrollContainerRef = useRef(null);
    const rowHeightsRef = useRef({});
    const [scrollSimulation, setScrollSimulation] = useState(0);
    // Общая высота таблицы с учетом все строк
    const [totalHeight, setTotalHeight] = useState(0);
    // Высота видимой области таблицы
    const [clientHeight, setClientHeight] = useState(0);
    //Разрешение на отправку запроса
    const [allowLoadMore, setAllowLoadMore] = useState(true);
    // Насколько близко к концу нужно доскроллить
    const LOAD_THRESHOLD = 400;
    const getItemSize = (index) => {
        return rowHeightsRef.current[index] ?? 58; // fallback только для старта
    };
    function useRowResizeObserver(index, listRef, rowHeightsRef) {
        const rowRef = useRef(null);
        useEffect(() => {
            if (!rowRef.current)
                return;
            const element = rowRef.current;
            const observer = new ResizeObserver((entries) => {
                const entry = entries[0];
                const height = entry.contentRect.height;
                if (rowHeightsRef.current[index] !== height) {
                    rowHeightsRef.current[index] = height;
                    listRef.current?.resetAfterIndex(index);
                }
            });
            observer.observe(element);
            return () => observer.disconnect();
        }, [index]);
        return rowRef;
    }
    const useThrottle = (callback, limit) => {
        const lastCallRef = useRef(0);
        return useCallback((...args) => {
            const now = Date.now();
            if (now - lastCallRef.current >= limit) {
                lastCallRef.current = now;
                callback(...args);
            }
        }, [callback, limit]);
    };
    const handleScroll = useThrottle((scrollOffset) => {
        const positionScroll = scrollOffset + clientHeight;
        if (!clientHeight && totalHeight <= 0) {
            return;
        }
        // четверть экрана
        const isScrollQuarterAndMore = positionScroll < totalHeight - 800;
        // низ экрана
        const isScrollEndOfTable = positionScroll > totalHeight - LOAD_THRESHOLD;
        if (isScrollEndOfTable && allowLoadMore) {
            if (loadMore)
                loadMore();
            //Запрет на отправку запроса
            setAllowLoadMore(false);
        }
        //Если выше четверти экрана разрешение на отправку запроса
        if (isScrollQuarterAndMore && !allowLoadMore) {
            setAllowLoadMore(true);
        }
    }, 100);
    const Row = ({ index, style }) => {
        const item = data[index];
        if (!item)
            return null;
        const rowRef = useRowResizeObserver(index, listRef, rowHeightsRef);
        const selected = isRowSelected?.(item) ?? false;
        const isLate = item.late > 0;
        const rowClassName = [
            rowBodyClassName,
            isLate && `${rowBodyClassName}--late`,
            selected && `${rowBodyClassName}--selected`,
        ]
            .filter(Boolean)
            .join(" ");
        return (_jsx("div", { style: style, children: _jsx("div", { ref: rowRef, className: rowClassName, style: {
                    display: "grid",
                    gridTemplateColumns,
                }, onClick: () => onRowClick?.(item), children: visibleColumns.map((colId) => {
                    const col = adjustedColumns[colId];
                    if (!col)
                        return null;
                    return (_jsx("div", { className: col.className, children: col.renderCell
                            ? col.renderCell(item)
                            : `Cell ${colId} - ${item.key}` }, colId));
                }) }) }));
    };
    return (_jsxs("div", { className: bodyClassName, style: { width: "100%", height: "calc(100% - 60px)" }, children: [_jsx(AutoSizer, { children: ({ height, width }) => (_jsx(VariableSizeList, { ref: listRef, height: height, width: width, itemCount: data.length, itemSize: getItemSize, outerRef: scrollContainerRef, style: { overflowX: "hidden" }, onScroll: (props) => {
                        handleScroll(props.scrollOffset);
                        setScrollSimulation(props.scrollOffset);
                    }, children: Row })) }), _jsx(ScrollButton, { targetRef: scrollContainerRef, outScroll: scrollSimulation })] }));
}
